import { BaseHttpResponseError } from './base-http.error';

/**
 * Error Code: 100 - This error occurs when user's Export/Download limit is "X" Records
 * per 24 hour period and the latest request includes Records that will take the user "Y"
 * Record(s) over his limits.
 */
export class ExportLogError extends BaseHttpResponseError {
  constructor(err) {
    super(err);
  }
}

/**
 * Error Code: 101 - This error occurs when user has pending exports currently active
 */
export class ActiveExportError extends BaseHttpResponseError {
  constructor(err) {
    super(err);
  }
}

/**
 * Error Code: 102 - This error occurs when the Export limit exceeded
 */
export class UserLimitReachedError extends BaseHttpResponseError {
  constructor(err) {
    super(err);
  }
}

/**
 * Error Code: 103 - This error occurs when User limits are not found or null
 */
export class DownloadLimitsNotSetError extends BaseHttpResponseError {
  constructor(err) {
    super(err);
  }
}
